import { Link } from "@tanstack/react-router";
import { Mail, Phone, Calendar, Ticket, Rss, Facebook, Twitter } from "lucide-react";
const logo = { url: "/media/investenergy-logo.png" };
import { useSite } from "./site-data";
import { FooterVenue } from "./FooterVenue";

export function SiteFooter() {
  const { settings } = useSite();
  const year = new Date().getFullYear();

  return (
    <footer className="relative overflow-hidden bg-ink text-ink-foreground">
      <div className="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-energy via-glow to-primary" />
      <div className="pointer-events-none absolute -right-24 -top-24 size-80 rounded-full bg-energy/10 blur-3xl" />
      <div className="pointer-events-none absolute -left-24 top-1/2 size-64 rounded-full bg-primary/10 blur-3xl" />

      <div className="relative mx-auto max-w-6xl px-6 pt-16 pb-10">
        {/* Top area: venue 2/3 + contact 1/3 */}
        <div className="grid items-stretch gap-6 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <FooterVenue />
          </div>

          <div className="flex h-full flex-col rounded-2xl border border-ink-foreground/10 bg-gradient-to-br from-white/[0.05] to-white/[0.02] p-6 text-center md:text-left">
            <h3 className="font-display text-sm font-bold uppercase tracking-widest text-ink-foreground/90">
              Contact
            </h3>
            <ul className="mt-5 flex flex-1 flex-col justify-center gap-4">
              <li className="flex flex-col items-center gap-2 text-center md:flex-row md:items-start md:justify-start md:text-left">
                <span className="inline-flex shrink-0 items-center justify-center rounded-xl bg-energy/15 p-2.5">
                  <Calendar className="size-4 text-energy" />
                </span>
                <span className="text-sm leading-snug text-ink-foreground/80">
                  6 octombrie 2026
                </span>
              </li>
              <li className="flex flex-col items-center gap-2 text-center md:flex-row md:items-start md:justify-start md:text-left">
                <span className="inline-flex shrink-0 items-center justify-center rounded-xl bg-energy/15 p-2.5">
                  <Mail className="size-4 text-energy" />
                </span>
                <a
                  href={`mailto:${settings["contact_email"]}`}
                  className="text-sm leading-snug text-ink-foreground/80 transition hover:text-energy"
                >
                  {settings["contact_email"]}
                </a>
              </li>
              <li className="flex flex-col items-center gap-2 text-center md:flex-row md:items-start md:justify-start md:text-left">
                <span className="inline-flex shrink-0 items-center justify-center rounded-xl bg-energy/15 p-2.5">
                  <Phone className="size-4 text-energy" />
                </span>
                <a
                  href={`tel:${(settings["contact_phone"] ?? "").replace(/\s/g, "")}`}
                  className="text-sm leading-snug text-ink-foreground/80 transition hover:text-energy"
                >
                  {settings["contact_phone"]}
                </a>
              </li>
            </ul>

            <Link
              to="/contact"
              className="mt-5 inline-flex w-fit items-center gap-2 self-center rounded-full bg-primary px-5 py-2.5 text-sm font-semibold text-primary-foreground transition hover:opacity-90 md:self-start"
            >
              <Ticket className="size-4" />
              Înscriere
            </Link>
          </div>
        </div>

        {/* Bottom area: single white logo + copyright */}
        <div className="mt-14 flex flex-col items-center gap-5 border-t border-ink-foreground/10 pt-8 text-center">
          <Link to="/" className="inline-block">
            <img
              src={logo.url}
              alt="InvesTenergy"
              className="h-10 w-auto brightness-0 invert"
            />
          </Link>
          <div className="space-y-3 text-xs text-ink-foreground/55">
            <p>© {year} InvesTenergy.ro. Toate drepturile rezervate.</p>
            <p>
              Dezvoltat de{" "}
              <a
                href="https://www.voitin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="font-medium text-energy transition hover:underline"
              >
                Voitin.com Web Services
              </a>
            </p>
            <ul className="flex items-center justify-center gap-3 pt-1">
              <li>
                <a
                  href="https://www.investenergy.ro/feed/"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="RSS"
                  className="inline-flex items-center justify-center rounded-full bg-white/10 p-2.5 text-white transition hover:bg-energy hover:text-white"
                >
                  <Rss className="size-4" />
                </a>
              </li>
              <li>
                <a
                  href="https://www.facebook.com/investenergy/"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Facebook"
                  className="inline-flex items-center justify-center rounded-full bg-white/10 p-2.5 text-white transition hover:bg-energy hover:text-white"
                >
                  <Facebook className="size-4" />
                </a>
              </li>
              <li>
                <a
                  href="https://twitter.com/investenergyro"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Twitter"
                  className="inline-flex items-center justify-center rounded-full bg-white/10 p-2.5 text-white transition hover:bg-energy hover:text-white"
                >
                  <Twitter className="size-4" />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}

